import Cookies from 'js-cookie';

import { scrollAnimate } from 'utils/scroll';
import pushEvent, { EVENT_CATALOG_CHANGE_VIEW } from 'pushEvent';
import { getStoreCookiePath } from 'store/common/settings/selectors';
import { contentContainerId } from 'pages/ProductCatalog/constants';

import {
  SET_CATALOG_DISPLAY_TYPE,
  SET_CATALOG_SORT_BY,
  SET_CATALOG_FILTERS_VALUES_CHANGED,
  SORT_BY_PRICE,
  SORT_BY_PRICE_DESC,
  SET_CATALOG_TOOGLE_FILTERS_BAR,
} from './constants';
import {
  getCatalogActiveSortBy,
  getCatalogDisplayTypeCookieName,
  getCatalogFiltersBarChangedState,
} from './selectors';
import { updateCatalogProducts, setFiltersBarChange } from '../actions';

export const setCatalogDisplayType = (payload) => (dispatch, getState) => {
  const state = getState();
  const path = getStoreCookiePath(state);

  /** change real value */
  dispatch({
    type: SET_CATALOG_DISPLAY_TYPE,
    payload,
  });

  /** change cookie value */
  const displayTypeCookieName = getCatalogDisplayTypeCookieName(state);
  Cookies.set(displayTypeCookieName, payload, { expires: 365, path });

  pushEvent(EVENT_CATALOG_CHANGE_VIEW, {
    type: payload === 'row' ? 'rows-list-icon' : 'tile-list-icon',
  });
};

export const setCatalogSortBy = (payload) => (dispatch, getState) => {
  const state = getState();
  const sortBy = getCatalogActiveSortBy(state);
  dispatch({
    type: SET_CATALOG_SORT_BY,
    payload,
  });

  /** only update content if something changed */
  if (sortBy !== payload) {
    dispatch(updateCatalogProducts({ shouldScrollUp: true }));
  }
};

export const setFiltersBarClose = () => (dispatch, getState) => {
  const state = getState();
  const filtersAreChanged = getCatalogFiltersBarChangedState(state);
  dispatch({
    type: SET_CATALOG_TOOGLE_FILTERS_BAR,
    payload: false,
  });
  if (filtersAreChanged) {
    const node = document.getElementById(contentContainerId);
    scrollAnimate(node);
  }
};

export const setFiltersBarOpen = () => (dispatch, getState) => {
  const state = getState();
  const filtersAreChanged = getCatalogFiltersBarChangedState(state);
  dispatch({
    type: SET_CATALOG_TOOGLE_FILTERS_BAR,
    payload: true,
  });
  if (filtersAreChanged) {
    dispatch(setFiltersBarChange(false));
  }
};

/**
 * extends setCatalogSortBy, controls sortBy and sort direction
 */
export const toggleCatalogSortBy = (payload) => (dispatch, getState) => {
  const state = getState();
  const sortBy = getCatalogActiveSortBy(state);

  /** if we were in price asc, we change to price desc, and vice versa */
  if (sortBy === payload && payload === SORT_BY_PRICE) {
    dispatch(setCatalogSortBy(SORT_BY_PRICE_DESC));
  } else if (sortBy === payload && payload === SORT_BY_PRICE_DESC) {
    dispatch(setCatalogSortBy(SORT_BY_PRICE));
  } else {
    dispatch(setCatalogSortBy(payload));
  }
};
